module.exports = __webpack_public_path__ + "img/heroe.feff2148.svg";